import { type ReactNode } from 'react';

export function useMealsSection(pricingVersion: number) {
  return (components: {
    defaultComponents: ReactNode;
    pricingVersion15andAboveComponents: ReactNode;
  }) => {
    const { defaultComponents, pricingVersion15andAboveComponents } =
      components;

    if (pricingVersion >= 15) {
      return pricingVersion15andAboveComponents;
    }

    return defaultComponents;
  };
}
